
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/threads/keyword/dashboard",
      function () {
        return require("private-next-pages/threads/keyword/dashboard/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/threads/keyword/dashboard"])
      });
    }
  